
import React, { useState } from 'react';
import { Button } from '../base/Button';

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-md z-50">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <div className="text-xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
          대청마을 북측 모아타운 사업성 평가 위원회
        </div>
        
        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center space-x-8">
          <button
            onClick={() => scrollToSection('overview')}
            className="text-gray-700 hover:text-green-500 transition-colors cursor-pointer"
          >
            사업개요
          </button>
          <button
            onClick={() => scrollToSection('asset-value')}
            className="text-gray-700 hover:text-green-500 transition-colors cursor-pointer"
          >
            자산가치
          </button>
          <button
            onClick={() => scrollToSection('process')}
            className="text-gray-700 hover:text-green-500 transition-colors cursor-pointer"
          >
            참여절차
          </button>
          <button
            onClick={() => scrollToSection('qna')}
            className="text-gray-700 hover:text-green-500 transition-colors cursor-pointer"
          >
            Q&A
          </button>
          <button
            onClick={() => scrollToSection('notice')}
            className="text-gray-700 hover:text-green-500 transition-colors cursor-pointer"
          >
            공지
          </button>
          <button
            onClick={() => scrollToSection('section-committee-about')}
            className="text-gray-700 hover:text-green-500 transition-colors cursor-pointer"
          >
            위원회 소개
          </button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => scrollToSection('consent-form')}
          >
            동의서 작성
          </Button>
        </nav>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="lg-hidden w-6 h-6 flex items-center justify-center cursor-pointer"
        >
          <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="lg:hidden bg-white border-t">
          <nav className="container mx-auto px-4 py-4 space-y-4">
            <button
              onClick={() => scrollToSection('overview')}
              className="block w-full text-left text-gray-700 hover:text-green-500 transition-colors cursor-pointer"
            >
              사업개요
            </button>
            <button
              onClick={() => scrollToSection('asset-value')}
              className="block w-full text-left text-gray-700 hover:text-green-500 transition-colors cursor-pointer"
            >
              자산가치
            </button>
            <button
              onClick={() => scrollToSection('process')}
              className="block w-full text-left text-gray-700 hover:text-green-500 transition-colors cursor-pointer"
            >
              참여절차
            </button>
            <button
              onClick={() => scrollToSection('qna')}
              className="block w-full text-left text-gray-700 hover:text-green-500 transition-colors cursor-pointer"
            >
              Q&A
            </button>
            <button
              onClick={() => scrollToSection('notice')}
              className="block w-full text-left text-gray-700 hover:text-green-500 transition-colors cursor-pointer"
            >
              공지
            </button>
            <button
              onClick={() => scrollToSection('section-committee-about')}
              className="block w-full text-left text-gray-700 hover:text-green-500 transition-colors cursor-pointer"
            >
              위원회 소개
            </button>
            <Button
              variant="outline"
              size="sm"
              onClick={() => scrollToSection('consent-form')}
              className="w-full"
            >
              동의서 작성
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
};
